import { render, staticRenderFns } from "./GroupBar.vue?vue&type=template&id=bbb950fc&scoped=true&"
import script from "./GroupBar.vue?vue&type=script&lang=js&"
export * from "./GroupBar.vue?vue&type=script&lang=js&"
import style0 from "./GroupBar.vue?vue&type=style&index=0&id=bbb950fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb950fc",
  null
  
)

export default component.exports